import { useQuery } from "@tanstack/react-query";

const useOrderStatus = (deliveryId) => {
  const statusQuery = useQuery({
    queryKey: ["orderStatus", deliveryId],
    enabled: false,
  });

  return statusQuery;
};

export default useOrderStatus;
